import { has } from 'lodash';

import {
  OVERRIDE_COMMENT_ATTACHMENTS,
  OPEN_ADD_COMMENT_ATTACHMENTS,
} from '../types';

const overrideCommentAttachments = function overrideCommentAttachments() {
  return (dispatch) => {
    dispatch({
      type: OVERRIDE_COMMENT_ATTACHMENTS,
    });
  };
};

const openAddCommentAttachment = function openAddCommentAttachment(workorderId) {
  return (dispatch, getState) => {
    const {
      session: { affiliateId },
    } = getState();
    if (
      window.AppInstall
      && has(window.AppInstall.info, 'overrides')
      && window.AppInstall.info.overrides.indexOf('commentAttachments') !== -1
    ) {
      window.AppInstall.triggerOverride('commentAttachments', {
        workorderId,
        affiliateId,
      });
    }
    dispatch({
      type: OPEN_ADD_COMMENT_ATTACHMENTS,
    });
  };
};

export default {
  openAddCommentAttachment,
  overrideCommentAttachments,
};



// WEBPACK FOOTER //
// ./src/state/actions/attachments.js